import React from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';
import ServerResults from './ResultsPages/ServerResults';
import ServerGroupEditor from './EditorPages/ServerGroupEditor';

function ServerGroups({
    urlParams
}) {
    const queryParams = queryString.parse(urlParams);

    return (
        queryParams && queryParams['id'] ?
            <ServerGroupEditor id={queryParams['id']} /> :
            <ServerResults />
    );
}

const mapStateToProps = (state) => ({
    urlParams: state.router.location.search,
});

export default connect(mapStateToProps, null)(ServerGroups);